import React from 'react'
import connect from 'front-end-core/decorators/connect'
import { requestDocDrafterTiledMenu, requestPrecedentsTiledMenu } from 'services/PrecedentsService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { DEFAULT_FLAVOUR } from 'constants/flavours'
import Menu from './Menu'

const ConnectedMenu = connect(({ aol }) => ({
  staticTiledMenu: requestPrecedentsTiledMenu({ flavour: DEFAULT_FLAVOUR, library: 'browse', aol }),
  drafterTiledMenu: requestDocDrafterTiledMenu({ aol })
}))((props) => (
  <ResponseConsumer
    responses={[props.staticTiledMenu, props.drafterTiledMenu]}
    skeleton='tiled-menu'
    content={() => <Menu {...props} />}
  />
))

export default ConnectedMenu
